import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getFavoriteContents } from "../../services/portalAluno/favorites/favoritesService";
import type { ApplicationState } from "../../store";

export const portalFavoritesQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "favoritos",
  idUsuario,
];

const useFavorites = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: Boolean(idUsuario),
    queryKey: portalFavoritesQueryKey(idUsuario),
    queryFn: () => getFavoriteContents(),
  });
};

export default useFavorites;
